
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from "react";
import axios from "axios";
import { GetServerSideProps } from "next/types";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { handleError } from "@/helpers/handleError";
import { notFoundSemCache } from "@/helpers/notFoundSemCache";
import { GET_HEADER_DATA } from "@/graphql/headerQueries";
import HeaderMenu from "@/components/HeaderMenu";
import { BreadcrumbType } from "@/Types/types";
import { breadcrumbInitial } from "@/data/breadcrumbInitial";
import dynamic from "next/dynamic";
import { GET_AUTHOR_ARTICLES_TOTAL, GET_POST, GET_POST_BY_ID, GET_SAFE_FIRST_POST, GET_SAFE_SECOND_POST } from "@/graphql/articleQueries";
import { GET_LATEST_CATEGORY_POSTS, GET_TOPICS_DATA } from "@/graphql/categoryQueries";
import { ONE_WEEK_IN_SECONDS } from "@/constants/timeConstants";
const PostPage = dynamic(() => import('@/components/PageComponents/PostPage'));
export default function Slug(props: any) {
    return (<>
      <HeaderMenu cookies={props.cookies.data} menu={props.navbar.data?.attributes.header_links}/>
      <PostPage {...props}/>
    </>);
}
const getServerSideProps: GetServerSideProps = async (context) => {
    try {
        context.res.setHeader("Cache-Control", `public, s-maxage=${ONE_WEEK_IN_SECONDS}, immutable`);
        const breadcrumbs: BreadcrumbType[] = JSON.parse(JSON.stringify(breadcrumbInitial));
        const client = new ApolloClient({
            uri: `${process.env.NEXT_PUBLIC_API_URL}/graphql`,
            cache: new InMemoryCache()
        });
        const { data: headerData } = await client.query({
            query: GET_HEADER_DATA
        });
        const { data: postData } = await client.query({
            query: GET_POST,
            variables: { slugUrl: context.params?.slug }
        });
        const { data: { articles: { meta: { pagination: { total: authorArticlesTotal } } } } } = await client.query({
            query: GET_AUTHOR_ARTICLES_TOTAL,
            variables: { authorId: postData.post.data[0].attributes.author.data.id }
        });
        const { data: categoryPosts } = await client.query({
            query: GET_LATEST_CATEGORY_POSTS,
            variables: {
                category: postData.post.data[0].attributes.category.data[0].attributes.title,
                id: postData.post.data[0].id
            }
        });
        const prevId = +postData.post.data[0].id === 1
            ? +postData.post.data[0].id + 2
            : +postData.post.data[0].id - 1;
        const { data: { articles: prevArticle }, } = await client.query({
            query: GET_POST_BY_ID,
            variables: { id: prevId }
        });
        const { data: { articles: nextArticle }, } = await client.query({
            query: GET_POST_BY_ID,
            variables: { id: +postData.post.data[0].id + 1 }
        });
        const { data: { articles: safeArticleOne }, } = await client.query({
            query: GET_SAFE_FIRST_POST
        });
        const { data: { articles: safeArticleTwo }, } = await client.query({
            query: GET_SAFE_SECOND_POST
        });
        const comments = await axios.get(`${process.env.NEXT_PUBLIC_API_URL}/api/comments/api::article.article:${postData.post.data[0].id}?filters[approvalStatus][$eq]=APPROVED&filters[blocked][$ne]=true`);
        const { data: topicsData } = await client.query({
            query: GET_TOPICS_DATA
        });
        breadcrumbs.push({
            href: `/categoria/${postData.post.data[0].attributes.category.data[0].attributes.slug}`,
            label: postData.post.data[0].attributes.category.data[0].attributes.title
        }, {
            href: `/${postData.post.data[0].attributes.url}`,
            label: postData.post.data[0].attributes.metaTitle
        });
        return {
            props: {
                ...postData,
                ...topicsData,
                ...categoryPosts,
                prevArticle,
                nextArticle,
                safeArticleOne,
                safeArticleTwo,
                authorArticlesTotal,
                comments: comments.data,
                ...headerData,
                breadcrumbs
            }
        };
    }
    catch (error) {
        handleError(error, "Slug getServerSideProps");
        return notFoundSemCache(context.res);
    }
};

    async function __Next_Translate__getServerSideProps__1a1756ceebb__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[slug]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1756ceebb__ as getServerSideProps }
  